import { render } from "./MoreApps.vue?vue&type=template&id=ca2d5710&scoped=true"
import script from "./MoreApps.vue?vue&type=script&lang=js"
export * from "./MoreApps.vue?vue&type=script&lang=js"

import "./MoreApps.vue?vue&type=style&index=0&id=ca2d5710&lang=scss&scoped=true"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca2d5710"]])

export default __exports__